import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { useLocation, useNavigate } from 'react-router';
import { Location } from 'history';
import { getVersionUrl } from 'common/cacheOverwrite';

const ApplyRequirements = () => {
  const screenId: string = "APPL24";

  const navigate = useNavigate();
  const location = useLocation() as Location<LocationState>;

  const {t, i18n} = useTranslation();

  const onNextClick = useCallback(() => {
    if (location.state.apply.isReissue) { // 카드 재발급으로 들어온 경우 핀코드 화면으로 바로 이동
      navigate('/apply/cardDesignSelect', {
        state: { ...location.state }
      });
    } else { // 재발급이 아닌 경우 동의화면으로 이동
      navigate('/apply/step1', {
        state: { ...location.state }
      });
    }
  }, [location.state, navigate]);

  // 뒤로가기 처리 (backKeyEvent_App (APP > WEB))
  const callbackBackKeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackKeyEvent);
    return () => document.removeEventListener("backpress", callbackBackKeyEvent);
  }, [callbackBackKeyEvent]);

  useEffect(() => {
    // 언어 설정
    i18n.changeLanguage(location.state.query.languageCode);
    // 타이틀 설정
    callNativeWeb(screenId, t(screenId + ".title", "CardApplication Requirements"));
    // 하단 메뉴 숨김처리
    footerShowEventWeb("N");

    // eslint-disable-next-line
  }, []);

  return(
    <div id="wrap">
      <div id="container" className="cardRequirementInfo pcHidden">
        <section className="contents">
          <p className={"title"}>{t(screenId + '.explan01', 'Please prepare below details for card application.')}</p>
          <div className={"roundedRectangleWrap"}>
            <div className={"content"}>
              <div>
                <p className={"header"}>{t(screenId + '.requirementHeader01', 'Card Delivery Address')}</p>
                <p className={"description"}>{t(screenId + '.requirementExplan01', 'You can upload the address photo instead of entering the address')}</p>
              </div>
              <div className={"imgWrap halfWidth"}>
                <img src={getVersionUrl('/assets/images/content/card_delivery_1.png')} alt={'Address 1'}/>
                <img className={"mgl24"} src={getVersionUrl('/assets/images/content/card_delivery_2.png')} alt={'Address 2'}/>
              </div>
            </div>
          </div>
          <div className={'btnArea'}>
            <button className={'btnPrimaryTy01'} onClick={onNextClick}>
              <span>Next</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ApplyRequirements;